import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-sticky-utility/dist/es6.js';

/* eslint-disable consistent-return */
/**
 * @class MarketingCodeUtility
 */
class MarketingCodeUtility {
  /**
   * Creates an instance of MarketingCodeUtility.
   * @param {Object} options Utility options
   * @memberof MarketingCodeUtility
   */
  constructor(options) {
    this.options = options;
  }

  /**
   * @param {String} sParam string parameter
   * @returns {String} url parameter
   */
  getURLParameter(sParam) {
    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split('&');
    for (let i = 0; i < sURLVariables.length; i++) {
      const sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] === sParam) {
        return sParameterName[1];
      }
    }
  }

  /**
   * Append Marketing Code
   *
   * @param {HTMLElement} buttonName button element
   * @return {undefined}
   */
  appendMarketingCode(buttonName) {
    const urlParam = window.location.search.substring(1);
    const mktgCodevalue = this.getURLParameter('mktgCode');
    const buttonPath = buttonName.href;
    if (urlParam === '' || !buttonPath.includes(urlParam)) {
      // storing mrktgcode value in session
      if (urlParam !== '' && urlParam !== undefined && urlParam.length !== '') {
        window.localStorage.setItem('urlParamSession', urlParam);
      }
      const queryString = window.localStorage.getItem('urlParamSession');
      if (queryString !== '' && queryString !== undefined && queryString != null) {
        if (!buttonPath.includes(queryString)) {
          const paramString = buttonPath.includes('?');
          const appendSymbol = paramString ? '&' : '?';
          buttonName.href = buttonPath + appendSymbol + queryString;
        }
      } else if (!buttonName.getAttribute('href').includes('&mktgCode')) {
        if (spartaStoreUtility.getData('currentMQ').viewport === 'small') {
          if (mktgCodevalue === '' || mktgCodevalue === undefined || mktgCodevalue.length === '') {
            buttonName.href = `${buttonPath}&mktgCode=mobiAuto`;
          }
        }
      }
      buttonName.addEventListener('click', () => {
        window.localStorage.removeItem('urlParamSession');
      });
    }
  }
}
const marketingCodeEvent = new MarketingCodeUtility();

export { marketingCodeEvent as default };
